// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Button from "../../html/Button.js";
import * as Buhta_cabinet__CalendarDatePickerInput from "../../molecules/CalendarDatePickerInput.js";
import * as Buhta_cabinet__CalendarMonthYearPickerInput from "../../molecules/CalendarMonthYearPickerInput.js";
import * as Buhta_cabinet__Checkbox from "../../html/Checkbox.js";
import * as Buhta_cabinet__Date from "../../../util/Date.js";
import * as Buhta_cabinet__Field from "../../html/Field.js";
import * as Buhta_cabinet__Modal from "../../molecules/Modal.js";
import * as Buhta_cabinet__PayrollHrm from "../../../grpc/PayrollHrm.js";
import * as Buhta_cabinet__RadioButton from "../../html/RadioButton.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__Select from "../../html/Select.js";
import * as Buhta_cabinet__TaxControl from "../../../grpc/TaxControl.js";
import * as Buhta_cabinet__Timestamp from "../../../util/Timestamp.js";
import * as Buhta_cabinet__ToastSender from "../../../util/ToastSender.js";
import * as Buhta_cabinet__Toggle from "../../atoms/Toggle.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../packages/core/lib/Toast.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as MelNumeral from "../../../../../../packages/util/lib/MelNumeral.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const disabledOptions = {
  hd: {
    value: /* PERSON_CATEGORY_DISABLED_GROUP_1 */3,
    text: "Инвалид I группы"
  },
  tl: {
    hd: {
      value: /* PERSON_CATEGORY_DISABLED_GROUP_2 */5,
      text: "Инвалид II группы"
    },
    tl: {
      hd: {
        value: /* PERSON_CATEGORY_DISABLED_GROUP_3 */7,
        text: "Инвалид III группы"
      },
      tl: /* [] */0
    }
  }
};

const permanentDisabledOptions = {
  hd: {
    value: /* PERSON_CATEGORY_DISABLED_GROUP_1_PERMANENT */4,
    text: "Инвалид I группы бессрочно"
  },
  tl: {
    hd: {
      value: /* PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT */6,
      text: "Инвалид II группы бессрочно"
    },
    tl: /* [] */0
  }
};

function make(contextRoute) {
  return function (isModalShown) {
    return function (setIsModalShown) {
      return function (hrmEvent) {
        return function (setHrmEvent) {
          return function (hrmEventError) {
            return function (setHrmEventError) {
              return function (employeeId) {
                return function (employee) {
                  return function (setRefresh) {
                    return function (refresh) {
                      const match = Buhta_core__Tenant.useTenant(undefined);
                      const tenant = match[0];
                      const match$1 = React.useState(function () {
                            return "";
                          });
                      const setNewSalary = match$1[1];
                      const newSalary = match$1[0];
                      const match$2 = React.useState(function () {
                            return "";
                          });
                      const setNewPosition = match$2[1];
                      const newPosition = match$2[0];
                      const match$3 = React.useState(function () {
                            return "";
                          });
                      const setChangesDate = match$3[1];
                      const changesDate = match$3[0];
                      const match$4 = React.useState(function () {
                            return "";
                          });
                      const setLayoffDate = match$4[1];
                      const layoffDate = match$4[0];
                      const match$5 = React.useState(function () {
                            return "";
                          });
                      const setSalary = match$5[1];
                      const salary = match$5[0];
                      const match$6 = React.useState(function () {
                            return "";
                          });
                      const setJobStartDate = match$6[1];
                      const jobStartDate = match$6[0];
                      const match$7 = React.useState(function () {
                            return "";
                          });
                      const setPosition = match$7[1];
                      const position = match$7[0];
                      const match$8 = React.useState(function () {
                            return false;
                          });
                      const setIsStandardTaxes = match$8[1];
                      const isStandardTaxes = match$8[0];
                      const match$9 = React.useState(function () {
                            return jobStartDate;
                          });
                      const setTaxesStartDate = match$9[1];
                      const taxesStartDate = match$9[0];
                      const match$10 = React.useState(function () {
                            return true;
                          });
                      const setGrossMethod = match$10[1];
                      const grossMethod = match$10[0];
                      const match$11 = React.useState(function () {
                            return true;
                          });
                      const setResident = match$11[1];
                      const resident = match$11[0];
                      const match$12 = React.useState(function () {
                            return true;
                          });
                      const setEResident = match$12[1];
                      const eResident = match$12[0];
                      const match$13 = React.useState(function () {
                            return true;
                          });
                      const setResidentPermit = match$13[1];
                      const residentPermit = match$13[0];
                      const match$14 = React.useState(function () {
                            return /* EMPLOYMENT_TYPE_UNSPECIFIED */0;
                          });
                      const setEmploymentType = match$14[1];
                      const employmentType = match$14[0];
                      const match$15 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
                      const dispatchToasts = match$15[1];
                      const match$16 = React.useState(function () {
                            return false;
                          });
                      const setIsBenefit = match$16[1];
                      const isBenefit = match$16[0];
                      const match$17 = React.useState(function () {
                            return false;
                          });
                      const setIsRetired = match$17[1];
                      const isRetired = match$17[0];
                      const match$18 = React.useState(function () {
                            return "";
                          });
                      const setRetiredStartDate = match$18[1];
                      const retiredStartDate = match$18[0];
                      const match$19 = React.useState(function () {
                            return false;
                          });
                      const setIsRetiredByYearsServed = match$19[1];
                      const isRetiredByYearsServed = match$19[0];
                      const match$20 = React.useState(function () {
                            return "";
                          });
                      const setRetiredDutyStartDate = match$20[1];
                      const retiredDutyStartDate = match$20[0];
                      const match$21 = React.useState(function () {
                            return false;
                          });
                      const setIsDisabled = match$21[1];
                      const isDisabled = match$21[0];
                      const match$22 = React.useState(function () {
                            return "";
                          });
                      const setDisabledStartDate = match$22[1];
                      const disabledStartDate = match$22[0];
                      const match$23 = React.useState(function () {
                            return "";
                          });
                      const setDisabledEndDate = match$23[1];
                      const disabledEndDate = match$23[0];
                      const match$24 = React.useState(function () {
                            return /* PERSON_CATEGORY_UNSPECIFIED */0;
                          });
                      const setDisabledCategory = match$24[1];
                      const disabledCategory = match$24[0];
                      const match$25 = React.useState(function () {
                            return /* PERSON_CATEGORY_UNSPECIFIED */0;
                          });
                      const setDisabledPermanentCategory = match$25[1];
                      const disabledPermanentCategory = match$25[0];
                      const match$26 = React.useState(function () {
                            return false;
                          });
                      const setIsDisabledIndefinitely = match$26[1];
                      const isDisabledIndefinitely = match$26[0];
                      const match$27 = React.useState(function () {
                            return "";
                          });
                      const setDisabledIndefinitelyStartDate = match$27[1];
                      const disabledIndefinitelyStartDate = match$27[0];
                      const match$28 = React.useState(function () {
                            return false;
                          });
                      const setIsParent = match$28[1];
                      const isParent = match$28[0];
                      const match$29 = React.useState(function () {
                            return "";
                          });
                      const setParentBenefitStartDate = match$29[1];
                      const parentBenefitStartDate = match$29[0];
                      const match$30 = React.useState(function () {
                            return 0;
                          });
                      const setChildren = match$30[1];
                      const children = match$30[0];
                      const match$31 = React.useState(function () {
                            return false;
                          });
                      const setIsMother = match$31[1];
                      const isMother = match$31[0];
                      const match$32 = React.useState(function () {
                            return "";
                          });
                      const setMotherBenefitStartDate = match$32[1];
                      const motherBenefitStartDate = match$32[0];
                      const match$33 = React.useState(function () {
                            return false;
                          });
                      const setIsStudent = match$33[1];
                      const isStudent = match$33[0];
                      const match$34 = React.useState(function () {
                            return "";
                          });
                      const setStudentBenefitStartDate = match$34[1];
                      const studentBenefitStartDate = match$34[0];
                      const match$35 = React.useState(function () {
                            return "";
                          });
                      const setStudentBenefitEndDate = match$35[1];
                      const studentBenefitEndDate = match$35[0];
                      const currentYear = DateTime.year(DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined));
                      let eventType;
                      switch (hrmEvent) {
                        case "CHANGE" :
                            eventType = /* EMPLOYMENT_EVENT_TYPE_CHANGE */2;
                            break;
                        case "START" :
                            eventType = /* EMPLOYMENT_EVENT_TYPE_START */1;
                            break;
                        case "TERMINATION" :
                            eventType = /* EMPLOYMENT_EVENT_TYPE_TERMINATION */3;
                            break;
                        default:
                          eventType = /* EMPLOYMENT_EVENT_TYPE_UNSPECIFIED */0;
                      }
                      let disabledCategory$1;
                      if (disabledCategory >= 8) {
                        disabledCategory$1 = /* PERSON_CATEGORY_UNSPECIFIED */0;
                      } else {
                        switch (disabledCategory) {
                          case /* PERSON_CATEGORY_UNSPECIFIED */0 :
                          case /* PERSON_CATEGORY_PENSIONER_AGE */1 :
                          case /* PERSON_CATEGORY_PENSIONER_DUTY */2 :
                          case /* PERSON_CATEGORY_DISABLED_GROUP_1_PERMANENT */4 :
                          case /* PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT */6 :
                              disabledCategory$1 = /* PERSON_CATEGORY_UNSPECIFIED */0;
                              break;
                          case /* PERSON_CATEGORY_DISABLED_GROUP_1 */3 :
                          case /* PERSON_CATEGORY_DISABLED_GROUP_2 */5 :
                          case /* PERSON_CATEGORY_DISABLED_GROUP_3 */7 :
                              disabledCategory$1 = disabledCategory;
                              break;
                          
                        }
                      }
                      const disabled_category_permanent = disabledPermanentCategory !== 4 && disabledPermanentCategory !== 6 ? /* PERSON_CATEGORY_UNSPECIFIED */0 : disabledPermanentCategory;
                      const emptyInfo = Curry.app(Buhta_cabinet__PayrollHrm.EmploymentInfo.make, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            "",
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined
                          ]);
                      const match$36 = employee.employment;
                      let info;
                      if (match$36 !== undefined) {
                        const info$1 = match$36.info;
                        info = info$1 !== undefined ? info$1 : emptyInfo;
                      } else {
                        info = emptyInfo;
                      }
                      React.useEffect((function () {
                              Curry._1(setNewPosition, (function (param) {
                                      return info.position;
                                    }));
                              Curry._1(setGrossMethod, (function (param) {
                                      return info.gross_method;
                                    }));
                              Curry._1(setEmploymentType, (function (param) {
                                      return info.employment_type;
                                    }));
                              Curry._1(setIsBenefit, (function (param) {
                                      return Stdlib__List.length(info.category_benefits) > 0;
                                    }));
                              Curry._1(setIsStandardTaxes, (function (param) {
                                      return Stdlib__List.length(info.tax_deduction_benefits) > 0;
                                    }));
                              const salary = info.salary_rate;
                              if (salary !== undefined) {
                                Curry._1(setNewSalary, (function (param) {
                                        return salary;
                                      }));
                              }
                              const __x = info.tax_deduction_benefits;
                              Belt__Belt_List.forEach(__x, (function (cb) {
                                      const match = cb["type'"];
                                      switch (match) {
                                        case /* TAX_DEDUCTION_TYPE_UNSPECIFIED */0 :
                                            return ;
                                        case /* TAX_DEDUCTION_TYPE_1_MZP */1 :
                                            Curry._1(setIsStandardTaxes, (function (param) {
                                                    return true;
                                                  }));
                                            return Curry._1(setTaxesStartDate, (function (param) {
                                                          const date = cb.begin_date;
                                                          if (date !== undefined) {
                                                            return Buhta_cabinet__Date.toString(date);
                                                          } else {
                                                            return "";
                                                          }
                                                        }));
                                        case /* TAX_DEDUCTION_TYPE_882_MRP */2 :
                                            Curry._1(setIsStandardTaxes, (function (param) {
                                                    return true;
                                                  }));
                                            return Curry._1(setTaxesStartDate, (function (param) {
                                                          const date = cb.begin_date;
                                                          if (date !== undefined) {
                                                            return Buhta_cabinet__Date.toString(date);
                                                          } else {
                                                            return "";
                                                          }
                                                        }));
                                        case /* TAX_DEDUCTION_TYPE_14_MRP */3 :
                                            Curry._1(setIsStandardTaxes, (function (param) {
                                                    return true;
                                                  }));
                                            return Curry._1(setTaxesStartDate, (function (param) {
                                                          const date = cb.begin_date;
                                                          if (date !== undefined) {
                                                            return Buhta_cabinet__Date.toString(date);
                                                          } else {
                                                            return "";
                                                          }
                                                        }));
                                        
                                      }
                                    }));
                              const __x$1 = info.category_benefits;
                              Belt__Belt_List.forEach(__x$1, (function (cb) {
                                      const match = cb.category;
                                      switch (match) {
                                        case /* PERSON_CATEGORY_PENSIONER_AGE */1 :
                                            Curry._1(setIsRetired, (function (param) {
                                                    return true;
                                                  }));
                                            return Curry._1(setRetiredStartDate, (function (param) {
                                                          const date = cb.begin_date;
                                                          if (date !== undefined) {
                                                            return Buhta_cabinet__Date.toString(date);
                                                          } else {
                                                            return "";
                                                          }
                                                        }));
                                        case /* PERSON_CATEGORY_PENSIONER_DUTY */2 :
                                            Curry._1(setIsRetiredByYearsServed, (function (param) {
                                                    return true;
                                                  }));
                                            return Curry._1(setRetiredDutyStartDate, (function (param) {
                                                          const date = cb.begin_date;
                                                          if (date !== undefined) {
                                                            return Buhta_cabinet__Date.toString(date);
                                                          } else {
                                                            return "";
                                                          }
                                                        }));
                                        case /* PERSON_CATEGORY_DISABLED_GROUP_2 */5 :
                                            Curry._1(setIsDisabled, (function (param) {
                                                    return true;
                                                  }));
                                            Curry._1(setDisabledStartDate, (function (param) {
                                                    const date = cb.begin_date;
                                                    if (date !== undefined) {
                                                      return Buhta_cabinet__Date.toString(date);
                                                    } else {
                                                      return "";
                                                    }
                                                  }));
                                            return Curry._1(setDisabledEndDate, (function (param) {
                                                          const match = cb.benefit;
                                                          if (typeof match === "string") {
                                                            return "";
                                                          }
                                                          if (match.NAME !== "Disabled") {
                                                            return "";
                                                          }
                                                          const date = match.VAL.end_date;
                                                          if (date !== undefined) {
                                                            return Buhta_cabinet__Date.toString(date);
                                                          } else {
                                                            return "";
                                                          }
                                                        }));
                                        case /* PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT */6 :
                                            Curry._1(setIsDisabledIndefinitely, (function (param) {
                                                    return true;
                                                  }));
                                            return Curry._1(setDisabledIndefinitelyStartDate, (function (param) {
                                                          const date = cb.begin_date;
                                                          if (date !== undefined) {
                                                            return Buhta_cabinet__Date.toString(date);
                                                          } else {
                                                            return "";
                                                          }
                                                        }));
                                        case /* PERSON_CATEGORY_GUARDIAN_DISABLED */9 :
                                            Curry._1(setIsParent, (function (param) {
                                                    return true;
                                                  }));
                                            return Curry._1(setParentBenefitStartDate, (function (param) {
                                                          const date = cb.begin_date;
                                                          if (date !== undefined) {
                                                            return Buhta_cabinet__Date.toString(date);
                                                          } else {
                                                            return "";
                                                          }
                                                        }));
                                        case /* PERSON_CATEGORY_UNSPECIFIED */0 :
                                        case /* PERSON_CATEGORY_DISABLED_GROUP_1 */3 :
                                        case /* PERSON_CATEGORY_DISABLED_GROUP_1_PERMANENT */4 :
                                        case /* PERSON_CATEGORY_DISABLED_GROUP_3 */7 :
                                        case /* PERSON_CATEGORY_VETERAN */8 :
                                        case /* PERSON_CATEGORY_GUARDIAN_ORPHANED */10 :
                                        case /* PERSON_CATEGORY_ADOPTER */11 :
                                        case /* PERSON_CATEGORY_CHILDREN */12 :
                                        case /* PERSON_CATEGORY_MATERNITY */13 :
                                        case /* PERSON_CATEGORY_CONVICT */14 :
                                            return ;
                                        case /* PERSON_CATEGORY_MOTHER_MANY */15 :
                                            Curry._1(setIsMother, (function (param) {
                                                    return true;
                                                  }));
                                            return Curry._1(setMotherBenefitStartDate, (function (param) {
                                                          const date = cb.begin_date;
                                                          if (date !== undefined) {
                                                            return Buhta_cabinet__Date.toString(date);
                                                          } else {
                                                            return "";
                                                          }
                                                        }));
                                        case /* PERSON_CATEGORY_STUDENT */16 :
                                            Curry._1(setIsStudent, (function (param) {
                                                    return true;
                                                  }));
                                            return Curry._1(setStudentBenefitStartDate, (function (param) {
                                                          const date = cb.begin_date;
                                                          if (date !== undefined) {
                                                            return Buhta_cabinet__Date.toString(date);
                                                          } else {
                                                            return "";
                                                          }
                                                        }));
                                        
                                      }
                                    }));
                            }), []);
                      const categories = JsxRuntime.jsxs(React.Fragment, {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    children: "Применить стандартный налоговый вычет"
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "w-5 h-5",
                                                    alt: "info",
                                                    src: StaticAsset.src("/static/icons/info.svg")
                                                  })
                                            ],
                                            className: "flex gap-2 items-center"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                                            checked: isStandardTaxes,
                                            onChange: (function (value) {
                                                Curry._1(setIsStandardTaxes, (function (param) {
                                                        return value;
                                                      }));
                                              })
                                          })
                                    ],
                                    className: "flex justify-between items-center mt-6 gap-2"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                          value: taxesStartDate,
                                          onPicked: (function (date) {
                                              Curry._1(setTaxesStartDate, (function (param) {
                                                      return DateTime.toDateFormat(date);
                                                    }));
                                            }),
                                          align: "BottomLeft",
                                          className: "w-full",
                                          label: "Начиная с"
                                        }),
                                    className: Cn.$plus("mt-2", Cn.on("hidden", !isStandardTaxes))
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    children: "Применить льготы"
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "w-5 h-5",
                                                    alt: "info",
                                                    src: StaticAsset.src("/static/icons/info.svg")
                                                  })
                                            ],
                                            className: "flex gap-2 items-center"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                                            checked: isBenefit,
                                            onChange: (function (value) {
                                                Curry._1(setIsBenefit, (function (param) {
                                                        return value;
                                                      }));
                                              })
                                          })
                                    ],
                                    className: "flex justify-between items-center mt-6"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: !resident,
                                            onChange: (function (param) {
                                                Curry._1(setResident, (function (param) {
                                                        return !resident;
                                                      }));
                                              }),
                                            text: "Не резидент РК"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: eResident,
                                            onChange: (function (param) {
                                                Curry._1(setEResident, (function (param) {
                                                        return !eResident;
                                                      }));
                                              }),
                                            text: "Резидент ЕврАзЭС",
                                            className: Cn.$plus("ml-6", Cn.on("hidden", resident))
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                            className: Cn.$plus("ml-6", Cn.on("hidden", resident)),
                                            checked: residentPermit === true,
                                            onChange: (function (param) {
                                                Curry._1(setResidentPermit, (function (param) {
                                                        return true;
                                                      }));
                                              }),
                                            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "ml-1",
                                                  children: "С видом на жительство РК"
                                                })
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                            className: Cn.$plus("ml-6", Cn.on("hidden", resident)),
                                            checked: residentPermit === false,
                                            onChange: (function (param) {
                                                Curry._1(setResidentPermit, (function (param) {
                                                        return false;
                                                      }));
                                              }),
                                            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "ml-1",
                                                  children: "Без вида на жительство РК"
                                                })
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: residentPermit,
                                            onChange: (function (param) {
                                                Curry._1(setResidentPermit, (function (param) {
                                                        return !residentPermit;
                                                      }));
                                              }),
                                            text: "Разрешение на работу",
                                            className: Cn.$plus("ml-6", Cn.on("hidden", resident))
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isRetired,
                                            onChange: (function (param) {
                                                Curry._1(setIsRetired, (function (param) {
                                                        return !isRetired;
                                                      }));
                                              }),
                                            text: "Пенсионер по возрасту",
                                            subText: "мужчины — 63, женщины — 61"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                  value: retiredStartDate,
                                                  onPicked: (function (date) {
                                                      Curry._1(setRetiredStartDate, (function (param) {
                                                              return DateTime.toDateFormat(date);
                                                            }));
                                                    }),
                                                  align: "BottomLeft",
                                                  label: "Дата начала льготы"
                                                }),
                                            className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isRetired))
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                                    isChecked: isRetiredByYearsServed,
                                                    onChange: (function (param) {
                                                        Curry._1(setIsRetiredByYearsServed, (function (param) {
                                                                return !isRetiredByYearsServed;
                                                              }));
                                                      }),
                                                    text: "Пенсионер по выслуге лет"
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "w-5 h-5",
                                                    alt: "info",
                                                    src: StaticAsset.src("/static/icons/info.svg")
                                                  })
                                            ],
                                            className: "flex gap-2 items-center"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                  value: retiredStartDate,
                                                  onPicked: (function (date) {
                                                      Curry._1(setRetiredStartDate, (function (param) {
                                                              return DateTime.toDateFormat(date);
                                                            }));
                                                    }),
                                                  align: "BottomLeft",
                                                  label: "Дата начала льготы"
                                                }),
                                            className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isRetiredByYearsServed))
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isDisabled,
                                            onChange: (function (param) {
                                                Curry._1(setIsDisabled, (function (param) {
                                                        return !isDisabled;
                                                      }));
                                              }),
                                            text: "Инвалид I, II, III группы"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Select.make, {
                                                    options: disabledOptions,
                                                    label: "Выберите группу",
                                                    size: "m",
                                                    selectedOption: Buhta_cabinet__Select.findInList(disabledOptions, disabledCategory$1),
                                                    onChange: (function (option) {
                                                        if (option !== undefined) {
                                                          return Curry._1(setDisabledCategory, (function (param) {
                                                                        return option.value;
                                                                      }));
                                                        } else {
                                                          return Curry._1(setDisabledCategory, (function (param) {
                                                                        return /* PERSON_CATEGORY_UNSPECIFIED */0;
                                                                      }));
                                                        }
                                                      })
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                                  value: disabledStartDate,
                                                                  onPicked: (function (date) {
                                                                      Curry._1(setDisabledStartDate, (function (param) {
                                                                              return DateTime.toDateFormat(date);
                                                                            }));
                                                                    }),
                                                                  align: "BottomLeft",
                                                                  label: "Дата начала льготы"
                                                                }),
                                                            className: "grow"
                                                          }),
                                                      JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                                  value: disabledEndDate,
                                                                  onPicked: (function (date) {
                                                                      Curry._1(setDisabledEndDate, (function (param) {
                                                                              return DateTime.toDateFormat(date);
                                                                            }));
                                                                    }),
                                                                  align: "BottomLeft",
                                                                  label: "Дата окончания"
                                                                }),
                                                            className: "grow"
                                                          })
                                                    ],
                                                    className: "flex gap-4 mt-2"
                                                  })
                                            ],
                                            className: Cn.$plus("mt-2 px-6 flex flex-col", Cn.on("hidden", !isDisabled))
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isDisabledIndefinitely,
                                            onChange: (function (param) {
                                                Curry._1(setIsDisabledIndefinitely, (function (param) {
                                                        return !isDisabledIndefinitely;
                                                      }));
                                              }),
                                            text: "Инвалид I, II группы бессрочно"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Select.make, {
                                                    options: permanentDisabledOptions,
                                                    label: "Выберите группу",
                                                    size: "m",
                                                    selectedOption: Buhta_cabinet__Select.findInList(permanentDisabledOptions, disabledPermanentCategory),
                                                    onChange: (function (option) {
                                                        if (option !== undefined) {
                                                          return Curry._1(setDisabledPermanentCategory, (function (param) {
                                                                        return option.value;
                                                                      }));
                                                        } else {
                                                          return Curry._1(setDisabledPermanentCategory, (function (param) {
                                                                        return /* PERSON_CATEGORY_UNSPECIFIED */0;
                                                                      }));
                                                        }
                                                      })
                                                  }),
                                              JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                    value: disabledIndefinitelyStartDate,
                                                    onPicked: (function (date) {
                                                        Curry._1(setDisabledIndefinitelyStartDate, (function (param) {
                                                                return DateTime.toDateFormat(date);
                                                              }));
                                                      }),
                                                    align: "BottomLeft",
                                                    className: "mt-2",
                                                    label: "Дата начала льготы"
                                                  })
                                            ],
                                            className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isDisabledIndefinitely))
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isParent,
                                            onChange: (function (param) {
                                                Curry._1(setIsParent, (function (param) {
                                                        return !isParent;
                                                      }));
                                              }),
                                            text: "Родитель/опекун инвалида"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                    value: parentBenefitStartDate,
                                                    onPicked: (function (date) {
                                                        Curry._1(setParentBenefitStartDate, (function (param) {
                                                                return DateTime.toDateFormat(date);
                                                              }));
                                                      }),
                                                    align: "BottomLeft",
                                                    className: "w-[209px]",
                                                    label: "Дата начала льгот"
                                                  }),
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    label: "Количество детей",
                                                    type_: "text",
                                                    name: "children",
                                                    size: "m",
                                                    required: true,
                                                    onChange: (function (value) {
                                                        Curry._1(setChildren, (function (param) {
                                                                try {
                                                                  return Caml_format.caml_int_of_string(value);
                                                                }
                                                                catch (exn){
                                                                  return 0;
                                                                }
                                                              }));
                                                      }),
                                                    className: "w-[209px]",
                                                    value: String(children)
                                                  })
                                            ],
                                            className: Cn.$plus("mt-2 px-6 flex items-center gap-4", Cn.on("hidden", !isParent))
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isMother,
                                            onChange: (function (param) {
                                                Curry._1(setIsMother, (function (param) {
                                                        return !isMother;
                                                      }));
                                              }),
                                            text: "Многодетная мать",
                                            subText: "4 и более детей"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                  value: motherBenefitStartDate,
                                                  onPicked: (function (date) {
                                                      Curry._1(setMotherBenefitStartDate, (function (param) {
                                                              return DateTime.toDateFormat(date);
                                                            }));
                                                    }),
                                                  align: "BottomLeft",
                                                  label: "Дата начала льготы"
                                                }),
                                            className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isMother))
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isStudent,
                                            onChange: (function (param) {
                                                Curry._1(setIsStudent, (function (param) {
                                                        return !isStudent;
                                                      }));
                                              }),
                                            text: "Студент"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                          value: studentBenefitStartDate,
                                                          onPicked: (function (date) {
                                                              Curry._1(setStudentBenefitStartDate, (function (param) {
                                                                      return DateTime.toDateFormat(date);
                                                                    }));
                                                            }),
                                                          align: "BottomLeft",
                                                          label: "Начало обучения"
                                                        }),
                                                    className: "grow"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                          value: studentBenefitEndDate,
                                                          onPicked: (function (date) {
                                                              Curry._1(setStudentBenefitEndDate, (function (param) {
                                                                      return DateTime.toDateFormat(date);
                                                                    }));
                                                            }),
                                                          align: "BottomLeft",
                                                          label: "Дата окончания"
                                                        }),
                                                    className: "grow"
                                                  })
                                            ],
                                            className: Cn.$plus("mt-2 px-6 flex gap-4", Cn.on("hidden", !isStudent))
                                          })
                                    ],
                                    className: Cn.$plus("space-y-4 mt-4", Cn.on("hidden", !isBenefit))
                                  })
                            ]
                          });
                      let hrmEventTitle;
                      switch (hrmEvent) {
                        case "CHANGE" :
                            hrmEventTitle = "Изменение";
                            break;
                        case "START" :
                            hrmEventTitle = "Начало работы";
                            break;
                        case "TERMINATION" :
                            hrmEventTitle = "Увольнение";
                            break;
                        default:
                          hrmEventTitle = "";
                      }
                      let tmp;
                      switch (hrmEvent) {
                        case "CHANGE" :
                            const rate = info.salary_rate;
                            tmp = JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                          value: changesDate,
                                          onPicked: (function (date) {
                                              Curry._1(setChangesDate, (function (param) {
                                                      return DateTime.toDateFormat(date);
                                                    }));
                                            }),
                                          align: "BottomLeft",
                                          className: "w-full",
                                          label: "Дата изменений",
                                          tillExactYear: currentYear + 2 | 0
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                          className: "text-default-gray font-semibold",
                                          children: "ТИП СОТРУДНИКА"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                  checked: employmentType === /* EMPLOYMENT_TYPE_SALARY */1,
                                                  onChange: (function (param) {
                                                      Curry._1(setEmploymentType, (function (param) {
                                                              return /* EMPLOYMENT_TYPE_SALARY */1;
                                                            }));
                                                    }),
                                                  children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                        className: "ml-1",
                                                        children: "Трудовой договор"
                                                      })
                                                }),
                                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                  checked: employmentType === /* EMPLOYMENT_TYPE_CONTRACT */2,
                                                  onChange: (function (param) {
                                                      Curry._1(setEmploymentType, (function (param) {
                                                              return /* EMPLOYMENT_TYPE_CONTRACT */2;
                                                            }));
                                                    }),
                                                  children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                        className: "ml-1",
                                                        children: "ГПХ"
                                                      })
                                                })
                                          ],
                                          className: "flex gap-6"
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                          className: "text-default-gray font-semibold",
                                          children: "МЕТОД РАСЧЕТА"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                  checked: grossMethod === true,
                                                  onChange: (function (param) {
                                                      Curry._1(setGrossMethod, (function (param) {
                                                              return true;
                                                            }));
                                                    }),
                                                  children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                        className: "ml-1",
                                                        children: [
                                                          "От обратного",
                                                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                                className: "text-gray-medium",
                                                                children: "Зарплата на руки"
                                                              })
                                                        ]
                                                      })
                                                }),
                                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                  checked: grossMethod === false,
                                                  onChange: (function (param) {
                                                      Curry._1(setGrossMethod, (function (param) {
                                                              return false;
                                                            }));
                                                    }),
                                                  children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                        className: "ml-1",
                                                        children: [
                                                          "Прямой расчет",
                                                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                                className: "text-gray-medium",
                                                                children: "Зарплата с налогами"
                                                              })
                                                        ]
                                                      })
                                                })
                                          ],
                                          className: "flex gap-6"
                                        }),
                                    rate !== undefined ? JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            placeholder: "Зарплата",
                                            name: "newSalary",
                                            size: "m",
                                            required: true,
                                            onChange: (function (value) {
                                                const cleanValue = value.replace(/\s/g, "");
                                                Curry._1(setNewSalary, (function (param) {
                                                        return cleanValue;
                                                      }));
                                              }),
                                            className: "w-full",
                                            value: newSalary.length !== 0 ? MelNumeral.formatSalary({
                                                    NAME: "Str",
                                                    VAL: newSalary
                                                  }) : ""
                                          }) : JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            placeholder: "Зарплата",
                                            name: "newSalary",
                                            size: "m",
                                            required: true,
                                            onChange: (function (value) {
                                                const cleanValue = value.replace(/\s/g, "");
                                                Curry._1(setNewSalary, (function (param) {
                                                        return cleanValue;
                                                      }));
                                              }),
                                            className: "w-full",
                                            value: MelNumeral.formatSalary({
                                                  NAME: "Str",
                                                  VAL: newSalary
                                                })
                                          }),
                                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                          placeholder: "Должность",
                                          name: "position",
                                          size: "m",
                                          required: true,
                                          onChange: (function (value) {
                                              Curry._1(setNewPosition, (function (param) {
                                                      return value;
                                                    }));
                                            }),
                                          className: "w-full",
                                          value: newPosition
                                        }),
                                    categories
                                  ],
                                  className: "flex flex-col gap-4 px-6 py-4"
                                });
                            break;
                        case "START" :
                            tmp = JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                          value: jobStartDate,
                                          onPicked: (function (date) {
                                              Curry._1(setJobStartDate, (function (param) {
                                                      return DateTime.toDateFormat(date);
                                                    }));
                                              Curry._1(setTaxesStartDate, (function (param) {
                                                      return DateTime.toDateFormat(date);
                                                    }));
                                            }),
                                          align: "BottomLeft",
                                          className: "w-full",
                                          label: "Дата начала работы"
                                        }),
                                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                          label: "Должность",
                                          type_: "text",
                                          name: "position",
                                          size: "m",
                                          onChange: (function (value) {
                                              Curry._1(setPosition, (function (param) {
                                                      return value;
                                                    }));
                                            }),
                                          value: position
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                          className: "text-default-gray font-semibold",
                                          children: "ТИП СОТРУДНИКА"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                  checked: employmentType === /* EMPLOYMENT_TYPE_SALARY */1,
                                                  onChange: (function (param) {
                                                      Curry._1(setEmploymentType, (function (param) {
                                                              return /* EMPLOYMENT_TYPE_SALARY */1;
                                                            }));
                                                    }),
                                                  children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                        className: "ml-1",
                                                        children: "Трудовой договор"
                                                      })
                                                }),
                                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                  checked: employmentType === /* EMPLOYMENT_TYPE_CONTRACT */2,
                                                  onChange: (function (param) {
                                                      Curry._1(setEmploymentType, (function (param) {
                                                              return /* EMPLOYMENT_TYPE_CONTRACT */2;
                                                            }));
                                                    }),
                                                  children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                        className: "ml-1",
                                                        children: "ГПХ"
                                                      })
                                                })
                                          ],
                                          className: "flex gap-6"
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                          className: "text-default-gray font-semibold",
                                          children: "МЕТОД РАСЧЕТА"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                  checked: grossMethod === true,
                                                  onChange: (function (param) {
                                                      Curry._1(setGrossMethod, (function (param) {
                                                              return true;
                                                            }));
                                                    }),
                                                  children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                        className: "ml-1",
                                                        children: [
                                                          "От обратного",
                                                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                                className: "text-gray-medium",
                                                                children: "Зарплата на руки"
                                                              })
                                                        ]
                                                      })
                                                }),
                                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                  checked: grossMethod === false,
                                                  onChange: (function (param) {
                                                      Curry._1(setGrossMethod, (function (param) {
                                                              return false;
                                                            }));
                                                    }),
                                                  children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                        className: "ml-1",
                                                        children: [
                                                          "Прямой расчет",
                                                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                                className: "text-gray-medium",
                                                                children: "Зарплата с налогами"
                                                              })
                                                        ]
                                                      })
                                                })
                                          ],
                                          className: "flex gap-6"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                  label: "Зарплата",
                                                  type_: "text",
                                                  name: "salary",
                                                  size: "m",
                                                  required: true,
                                                  onChange: (function (value) {
                                                      const cleanValue = value.replace(/\s/g, "");
                                                      Curry._1(setSalary, (function (param) {
                                                              return cleanValue;
                                                            }));
                                                    }),
                                                  value: salary.length !== 0 ? MelNumeral.formatSalary({
                                                          NAME: "Str",
                                                          VAL: salary
                                                        }) : ""
                                                }),
                                            JsxRuntime.jsx("img", {
                                                  className: "absolute right-4 top-4 w-5 h-5",
                                                  alt: "tenge",
                                                  src: StaticAsset.src("/static/icons/tenge.svg")
                                                }),
                                            JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                                                  className: "text-asphalt mt-1",
                                                  children: [
                                                    "Минимальная сумма — ",
                                                    JsxRuntime.jsx("span", {
                                                          children: "85 000 ₸",
                                                          className: "text-links cursor-pointer",
                                                          onClick: (function (param) {
                                                              Curry._1(setSalary, (function (param) {
                                                                      return "85000";
                                                                    }));
                                                            })
                                                        })
                                                  ]
                                                })
                                          ],
                                          className: "relative"
                                        }),
                                    categories
                                  ],
                                  className: "flex flex-col gap-4 px-6 py-4"
                                });
                            break;
                        case "TERMINATION" :
                            tmp = JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_cabinet__CalendarMonthYearPickerInput.make, {
                                          value: layoffDate,
                                          onPicked: (function (date) {
                                              Curry._1(setLayoffDate, (function (param) {
                                                      return DateTime.toDateFormat(date);
                                                    }));
                                            }),
                                          align: "BottomLeft",
                                          className: "w-full z-50",
                                          label: "Дата увольнения"
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: "mt-4 text-gray-medium",
                                          children: "Дата увольнения будет считаться последним днем выбранного месяца"
                                        })
                                  ],
                                  className: "px-6 pb-4"
                                });
                            break;
                        default:
                          tmp = null;
                      }
                      return JsxRuntime.jsx(Buhta_cabinet__Modal.make, {
                                  isShown: isModalShown,
                                  onClose: (function (param) {
                                      Curry._1(setIsModalShown, (function (param) {
                                              return false;
                                            }));
                                    }),
                                  title: hrmEventTitle,
                                  children: JsxRuntime.jsxs("form", {
                                        children: [
                                          tmp,
                                          JsxRuntime.jsx("hr", {}),
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                                      type_: "submit",
                                                      isWide: true,
                                                      children: "Добавить"
                                                    }),
                                                className: "px-6 py-4"
                                              })
                                        ],
                                        onSubmit: (function (ev) {
                                            ev.preventDefault();
                                            const retiredBenefit = Curry._4(Buhta_cabinet__TaxControl.PersonCategoryBenefit.make, /* PERSON_CATEGORY_PENSIONER_AGE */1, retiredStartDate !== "" ? Buhta_cabinet__Date.fromString(retiredStartDate) : undefined, undefined, undefined);
                                            const retiredDutyBenefit = Curry._4(Buhta_cabinet__TaxControl.PersonCategoryBenefit.make, /* PERSON_CATEGORY_PENSIONER_DUTY */2, retiredDutyStartDate !== "" ? Buhta_cabinet__Date.fromString(retiredDutyStartDate) : undefined, undefined, undefined);
                                            const disabledBenefit = Curry._4(Buhta_cabinet__TaxControl.PersonCategoryBenefit.make, disabledCategory$1, disabledStartDate !== "" ? Buhta_cabinet__Date.fromString(disabledStartDate) : undefined, {
                                                  NAME: "Disabled",
                                                  VAL: {
                                                    end_date: disabledEndDate !== "" ? Buhta_cabinet__Date.fromString(disabledEndDate) : undefined
                                                  }
                                                }, undefined);
                                            const disabledIndefinitelyBenefit_begin_date = disabledIndefinitelyStartDate !== "" ? Buhta_cabinet__Date.fromString(disabledIndefinitelyStartDate) : undefined;
                                            const disabledIndefinitelyBenefit_benefit = {
                                              NAME: "Disabled_permanent",
                                              VAL: undefined
                                            };
                                            const disabledIndefinitelyBenefit = {
                                              category: disabled_category_permanent,
                                              begin_date: disabledIndefinitelyBenefit_begin_date,
                                              benefit: disabledIndefinitelyBenefit_benefit
                                            };
                                            const parentBenefit_begin_date = parentBenefitStartDate !== "" ? Buhta_cabinet__Date.fromString(parentBenefitStartDate) : undefined;
                                            const parentBenefit_benefit = {
                                              NAME: "Guardian_disabled",
                                              VAL: {
                                                children: children > 0 ? children : undefined
                                              }
                                            };
                                            const parentBenefit = {
                                              category: /* PERSON_CATEGORY_GUARDIAN_DISABLED */9,
                                              begin_date: parentBenefit_begin_date,
                                              benefit: parentBenefit_benefit
                                            };
                                            const motherBenefit_begin_date = motherBenefitStartDate !== "" ? Buhta_cabinet__Date.fromString(motherBenefitStartDate) : undefined;
                                            const motherBenefit_benefit = {
                                              NAME: "Mother_many",
                                              VAL: undefined
                                            };
                                            const motherBenefit = {
                                              category: /* PERSON_CATEGORY_MOTHER_MANY */15,
                                              begin_date: motherBenefit_begin_date,
                                              benefit: motherBenefit_benefit
                                            };
                                            const studentBenefit_begin_date = studentBenefitStartDate !== "" ? Buhta_cabinet__Date.fromString(studentBenefitStartDate) : undefined;
                                            const studentBenefit_benefit = {
                                              NAME: "Student",
                                              VAL: {
                                                end_date: studentBenefitEndDate !== "" ? Buhta_cabinet__Date.fromString(studentBenefitEndDate) : undefined
                                              }
                                            };
                                            const studentBenefit = {
                                              category: /* PERSON_CATEGORY_STUDENT */16,
                                              begin_date: studentBenefit_begin_date,
                                              benefit: studentBenefit_benefit
                                            };
                                            const taxDeductionBenefits_begin_date = taxesStartDate !== "" ? Buhta_cabinet__Date.fromString(taxesStartDate) : undefined;
                                            const taxDeductionBenefits = {
                                              "type'": /* TAX_DEDUCTION_TYPE_14_MRP */3,
                                              begin_date: taxDeductionBenefits_begin_date,
                                              end_date: undefined
                                            };
                                            const categoryBenefits = Stdlib.$at(/* [] */0, Stdlib.$at(isRetired ? ({
                                                          hd: retiredBenefit,
                                                          tl: /* [] */0
                                                        }) : /* [] */0, Stdlib.$at(isRetiredByYearsServed ? ({
                                                              hd: retiredDutyBenefit,
                                                              tl: /* [] */0
                                                            }) : /* [] */0, Stdlib.$at(isDisabled ? ({
                                                                  hd: disabledBenefit,
                                                                  tl: /* [] */0
                                                                }) : /* [] */0, Stdlib.$at(isDisabledIndefinitely ? ({
                                                                      hd: disabledIndefinitelyBenefit,
                                                                      tl: /* [] */0
                                                                    }) : /* [] */0, Stdlib.$at(isParent ? ({
                                                                          hd: parentBenefit,
                                                                          tl: /* [] */0
                                                                        }) : /* [] */0, Stdlib.$at(isMother ? ({
                                                                              hd: motherBenefit,
                                                                              tl: /* [] */0
                                                                            }) : /* [] */0, isStudent ? ({
                                                                              hd: studentBenefit,
                                                                              tl: /* [] */0
                                                                            }) : /* [] */0)))))));
                                            const taxDeductionBenefits$1 = Stdlib.$at(/* [] */0, isStandardTaxes ? ({
                                                      hd: taxDeductionBenefits,
                                                      tl: /* [] */0
                                                    }) : /* [] */0);
                                            const form_event_date = jobStartDate !== "" ? Buhta_cabinet__Date.fromString(jobStartDate) : (
                                                changesDate !== "" ? Buhta_cabinet__Date.fromString(changesDate) : (
                                                    layoffDate !== "" ? Buhta_cabinet__Date.fromString(layoffDate) : undefined
                                                  )
                                              );
                                            const form_info = {
                                              resident: resident,
                                              eaeu_resident: eResident,
                                              has_residence_permit: residentPermit,
                                              employment_type: employmentType,
                                              position: newPosition !== "" ? newPosition : position,
                                              tax_deduction_benefits: taxDeductionBenefits$1,
                                              category_benefits: categoryBenefits,
                                              salary_rate: salary !== "" ? salary : newSalary,
                                              mzp_salary: salary === "85000",
                                              effective_salary_rate: undefined,
                                              gross_method: grossMethod
                                            };
                                            const form = {
                                              event_type: eventType,
                                              event_date: form_event_date,
                                              info: form_info
                                            };
                                            const __x = Buhta_cabinet__PayrollHrm.EmploymentService.create(tenant, employeeId, form);
                                            $$Promise.get(__x, (function (result) {
                                                    if (result.TAG === /* Ok */0) {
                                                      Curry._1(setIsModalShown, (function (param) {
                                                              return false;
                                                            }));
                                                      Curry._1(setRefresh, (function (param) {
                                                              return -refresh | 0;
                                                            }));
                                                      return Curry._1(dispatchToasts, {
                                                                  TAG: /* Add */0,
                                                                  _0: {
                                                                    id: Buhta_core__Toast.generateId(undefined),
                                                                    text: "Кадровое событие успешно создано",
                                                                    kind: "success",
                                                                    onClick: (function (param) {
                                                                        
                                                                      })
                                                                  }
                                                                });
                                                    }
                                                    const err = result._0;
                                                    console.log("err", err);
                                                    let neededDate;
                                                    switch (eventType) {
                                                      case /* EMPLOYMENT_EVENT_TYPE_UNSPECIFIED */0 :
                                                          neededDate = "";
                                                          break;
                                                      case /* EMPLOYMENT_EVENT_TYPE_START */1 :
                                                          neededDate = jobStartDate;
                                                          break;
                                                      case /* EMPLOYMENT_EVENT_TYPE_CHANGE */2 :
                                                          neededDate = changesDate;
                                                          break;
                                                      case /* EMPLOYMENT_EVENT_TYPE_TERMINATION */3 :
                                                          neededDate = layoffDate;
                                                          break;
                                                      
                                                    }
                                                    Buhta_cabinet__ToastSender.sendToastHrmEvents(dispatchToasts, err, "Ошибка при создании кадрового события: ", neededDate);
                                                  }));
                                          })
                                      }),
                                  wrapperClassName: "w-[562px] max-h-full overflow-y-auto"
                                });
                    };
                  };
                };
              };
            };
          };
        };
      };
    };
  };
}

function HrmEmployeeHrmEvents$HrmEventsModal(Props) {
  return Curry.app(make(Props.contextRoute)(Props.isModalShown), [
              Props.setIsModalShown,
              Props.hrmEvent,
              Props.setHrmEvent,
              Props.hrmEventError,
              Props.setHrmEventError,
              Props.employeeId,
              Props.employee,
              Props.setRefresh,
              Props.refresh
            ]);
}

const HrmEventsModal = {
  make: HrmEmployeeHrmEvents$HrmEventsModal
};

function make$1(org) {
  return function (employee) {
    return function (employeeId) {
      return function (isModalShownOpt) {
        const isModalShown = isModalShownOpt !== undefined ? isModalShownOpt : false;
        return function (setIsModalShownOpt) {
          const setIsModalShown = setIsModalShownOpt !== undefined ? setIsModalShownOpt : (function (param) {
                
              });
          return function (hrmEventOpt) {
            const hrmEvent = hrmEventOpt !== undefined ? hrmEventOpt : "";
            return function (setHrmEventOpt) {
              const setHrmEvent = setHrmEventOpt !== undefined ? setHrmEventOpt : (function (param) {
                    
                  });
              return function (showEventsHistoryOpt) {
                const showEventsHistory = showEventsHistoryOpt !== undefined ? showEventsHistoryOpt : true;
                return function (refreshOpt) {
                  const refresh = refreshOpt !== undefined ? refreshOpt : 1;
                  return function (setRefreshOpt) {
                    const setRefresh = setRefreshOpt !== undefined ? setRefreshOpt : (function (param) {
                          
                        });
                    const match = React.useState(function () {
                          return "";
                        });
                    const match$1 = Buhta_core__Tenant.useTenant(undefined);
                    const tenant = match$1[0];
                    const contextRoute = function (route) {
                      return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
                    };
                    const arg = employeeId;
                    const func = Buhta_cabinet__PayrollHrm.EmploymentService.grid;
                    const match$2 = Buhta_core__GrpcState.useGrid((function (param) {
                            return Curry._2(func, param, arg);
                          }), undefined);
                    const dispatch = match$2[1];
                    const grid = match$2[0];
                    React.useEffect((function () {
                            Curry._3(dispatch, undefined, undefined, undefined);
                          }), []);
                    const employee$1 = employee !== undefined ? employee : ({
                          id: "",
                          serial_id: 0,
                          tin: "",
                          family_name: "",
                          given_name: "",
                          patronymic_name: "",
                          birthday_date: undefined,
                          address: undefined,
                          email: "",
                          phone: "",
                          employment: undefined,
                          create_time: undefined,
                          update_time: undefined
                        });
                    let tmp;
                    if (showEventsHistory) {
                      let tmp$1;
                      if (typeof grid === "string" || grid.NAME !== "Data") {
                        tmp$1 = /* [] */0;
                      } else {
                        const events = grid.VAL;
                        tmp$1 = Stdlib__List.mapi((function (i, $$event) {
                                console.log("events", events);
                                const create_time = DateTime.toDateFormat(Buhta_cabinet__Timestamp.toDateTime(Belt__Belt_Option.getWithDefault($$event.create_time, Buhta_cabinet__Timestamp.fromString("01.01.2000"))));
                                const date = $$event.event_date;
                                const event_date = date !== undefined ? Buhta_cabinet__Date.toDayMonthString(date) : "—";
                                const Key = String(i);
                                const match = $$event.event_type;
                                let tmp;
                                switch (match) {
                                  case /* EMPLOYMENT_EVENT_TYPE_UNSPECIFIED */0 :
                                      tmp = null;
                                      break;
                                  case /* EMPLOYMENT_EVENT_TYPE_START */1 :
                                      tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: "Начало работы"
                                          });
                                      break;
                                  case /* EMPLOYMENT_EVENT_TYPE_CHANGE */2 :
                                      tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: "Изменение"
                                          });
                                      break;
                                  case /* EMPLOYMENT_EVENT_TYPE_TERMINATION */3 :
                                      tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            children: "Увольнение"
                                          });
                                      break;
                                  
                                }
                                return JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("hr", {
                                                    className: "my-4 bg-gray-light"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsxs("div", {
                                                            children: [
                                                              tmp,
                                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                    className: "text-gray-medium",
                                                                    children: create_time
                                                                  })
                                                            ],
                                                            className: "flex flex-col gap-1"
                                                          }),
                                                      JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                            className: "flex gap-2 items-center",
                                                            children: [
                                                              event_date,
                                                              JsxRuntime.jsx("img", {
                                                                    alt: "buhta more",
                                                                    src: StaticAsset.src("/static/icons/more-asphalt-20.svg")
                                                                  })
                                                            ]
                                                          })
                                                    ],
                                                    className: "flex items-center justify-between"
                                                  })
                                            ]
                                          }, Key);
                              }), events);
                      }
                      tmp = JsxRuntime.jsx(React.Fragment, {
                            children: JsxRuntime.jsx("div", {
                                  children: Belt__Belt_List.toArray(tmp$1),
                                  className: ""
                                })
                          });
                    } else {
                      tmp = null;
                    }
                    return JsxRuntime.jsxs("div", {
                                children: [
                                  tmp,
                                  JsxRuntime.jsx(HrmEmployeeHrmEvents$HrmEventsModal, {
                                        contextRoute: contextRoute,
                                        isModalShown: isModalShown,
                                        setIsModalShown: setIsModalShown,
                                        hrmEvent: hrmEvent,
                                        setHrmEvent: setHrmEvent,
                                        hrmEventError: match[0],
                                        setHrmEventError: match[1],
                                        employeeId: employeeId,
                                        employee: employee$1,
                                        setRefresh: setRefresh,
                                        refresh: refresh
                                      })
                                ]
                              });
                  };
                };
              };
            };
          };
        };
      };
    };
  };
}

function HrmEmployeeHrmEvents(Props) {
  return Curry._8(make$1(Props.org)(Props.employee), Props.employeeId, Props.isModalShown, Props.setIsModalShown, Props.hrmEvent, Props.setHrmEvent, Props.showEventsHistory, Props.refresh, Props.setRefresh);
}

const make$2 = HrmEmployeeHrmEvents;

export {
  disabledOptions ,
  permanentDisabledOptions ,
  HrmEventsModal ,
  make$2 as make,
}
/* Buhta_cabinet__Button Not a pure module */
